
import { REGION_ENVIRONMENT } from 'SharedDir/constants/common';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NotFoundData',
  setup(props, { slots }) {
    return { props, slots, REGION_ENVIRONMENT };
  },
});
